import { NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateCacheModule, TranslateCacheService, TranslateCacheSettings } from 'ngx-translate-cache';

@NgModule({
  imports: [
    HttpClientModule,
    TranslateCacheModule.forRoot({
      cacheService: {
        provide: TranslateCacheService,
        useFactory: (translateService: TranslateService, translateCacheSettings: TranslateCacheSettings) => {
          return new TranslateCacheService(translateService, translateCacheSettings)
        },
        deps: [TranslateService, TranslateCacheSettings],
      },
      cacheName: 'lang', // default value is 'lang'.
      cacheMechanism: 'LocalStorage', // default value is 'LocalStorage'.
      cookieExpiry: 1, // default value is 720, a month. Set to a negative value and the cookie becomes a session cookie.
    })
  ],
  exports: [TranslateModule]
})
export class I18nModule {
  constructor(translate: TranslateService, translateCacheService: TranslateCacheService) {
    translate.addLangs(['en', 'hi']);
    //get lang name
    let preLang = localStorage.getItem('lang');
    if (preLang == undefined || preLang == null || preLang=="") {
      translate.setDefaultLang('en');
      translate.use('en');
    }
    else {
      // translate.setDefaultLang('en');
      // translate.use('en');
      translate.setDefaultLang(preLang);
      translate.use(preLang);
    }
    translateCacheService.init();
  }
}

export function translateLoaderFactory(httpClient: HttpClient) {
  // return new TranslateHttpLoader(httpClient);
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}